import { useEffect, useState } from "react";
import { UserModel } from "../../../../../context_providers/auth/user_model";
import { GetEmployeesByDept } from "../../../../../service/repos/users_repo";
import { SubDepartments } from "../../../../../utils/enums";
import EmpCard from "../../dept-employees/components/EmpCard";
import Layout from "../../layout";

const EmployeesList = ({ match }: { match: any }) => {
  const [employees, setEmployees] = useState<UserModel[]>([]);
  const [count, setCount] = useState<number>(0);

  const getData = async () => {
    const res = await GetEmployeesByDept(
      match.params.dept,
      match.params.subdept === "all" ? undefined : match.params.subdept
    );
    if (res.success) {
      let data = res.data.data;

      setEmployees(data);

      // counting active employees
      const activeCount = data.filter((d: any) => d.emp_profile?.active).length;
      setCount(activeCount);
    } else {
      setEmployees([]);
    }
  };

  const getLogo = (dept: string) => {
    const deps = Object.keys(SubDepartments);

    switch (dept) {
      case deps[0]:
        return "accounts";
      case deps[1]:
        return "strategy";
      case deps[2]:
        return "procurement";
      case deps[3]:
        return "hr";
      case deps[4]:
        return "management1";
      case deps[5]:
        return "sales";
      case deps[6]:
        return "content";
      case deps[7]:
        return "operations";
      case deps[8]:
        return "tech";
      case deps[9]:
        return "design";

      default:
        return "nothing";
    }
  };

  useEffect(() => {
    getData();
  }, [match.params.dept, match.params.subdept]);

  return (
    <Layout pageTitle="EmployeesList">
      <div className="py-4 lg:px-2">
        <div className="flex items-center gap-2">
          <div className="ml-1 text-xl">
            {match.params.subdept
              ? match.params.subdept.toLowerCase() === "all"
                ? (employees[0]?.emp_profile?.department || match.params.dept) +
                  " Team"
                : match.params.subdept.split("_").join(" ") + " Team"
              : (employees[0]?.emp_profile?.department || match.params.dept) +
                " Team"}
          </div>

          <div className="h-4 w-px bg-black"></div>
          <div className="ml-1 my-4 font-semibold text-secondaryColor dark:text-primaryColor">
            {count} People
          </div>
        </div>

        <>
          <div className="mt-8 lg:mt-12">
            <div className="flex items-center">
              <div className="font-semibold text-green-500">Active</div>
              <div className="w-2 h-2 rounded-full bg-green-500 ml-1"></div>
            </div>
            <div className="grid grid-cols-1 lg:grid-cols-4 lg:gap-x-2 gap-y-4 lg:gap-y-7 mt-2">
              {employees
                .filter((d) => d.emp_profile?.active)
                .map((item, i) => (
                  <EmpCard emp={item} key={i} />
                ))}
            </div>
          </div>

          {employees.some((d) => !d.emp_profile?.active) && (
            <div className="mt-32 lg:mt-64">
              <div className="flex items-center">
                <div className="text-xl font-semibold text-red-600">
                  Inactive
                </div>
                <div className="w-2 h-2 rounded-full bg-red-600 ml-1"></div>
              </div>
              <div className="grid grid-cols-1 lg:grid-cols-4 gap-x-12 gap-y-7 mt-2">
                {employees
                  .filter((d) => !d.emp_profile?.active)
                  .map((item, i) => (
                    <EmpCard emp={item} key={i} />
                  ))}
              </div>
            </div>
          )}
        </>
      </div>
    </Layout>
  );
};

export default EmployeesList;
